import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo, useState } from "react";

import ListParameters from "./ListParameters.graphql";
import ParameterCard from "./ParameterCard";
import InventoryMenu from "../../../components/InventoryMenu";
import InventorySearch from "../../../components/InventorySearch";
import LetterGroups from "../../../components/Letters/LetterGroups";
import Letters from "../../../components/Letters/Letters";

function firstLetterSelector(parameter) {
    return parameter.name[0].text.toLowerCase()[0];
}

const filters = {
    all: () => true,
    deprecated: (bimClass) => {
        return !!bimClass.deprecated;
    },
    nondeprecated: (bimClass) => {
        return !bimClass.deprecated;
    },
};

export default function ParameterList(props) {
    const { guard } = props;
    const listParameters = useQuery(gql(ListParameters));
    const parameters = listParameters.data?.parameters ?? [];

    const [textSearch, setTextSearch] = useState("");
    const [filter, setFilter] = useState("nondeprecated");

    const matchingParameters = useMemo(
        () => parameters
            .filter(
                (parameter) => filters[filter](parameter) ?? true
            )
            .filter(
                (parameter) => [
                    parameter.name[0].text.toLowerCase().includes(textSearch.toLowerCase()),
                    parameter.id.toLowerCase().includes(textSearch.toLowerCase()),
                    parameter.guid.toLowerCase().replaceAll("-", "").includes(textSearch.toLowerCase().replaceAll("-", "")),
                ].includes(true)
            )
            .sort(
                (a, b) => a.name[0].text.localeCompare(b.name[0].text),
            ),
        [parameters, filter, textSearch],
    );

    if (listParameters.loading) return "loading";
    if (listParameters.error) return "error";

    return (
        <>
            <InventoryMenu>
                <Letters
                    active={ matchingParameters } all={ parameters } selector={ firstLetterSelector }
                />
                <InventorySearch
                    onChange={ (e) => setTextSearch(e.target.value) } placeholder="search Parameters" value={ textSearch }
                />
                <select
                    onChange={ (event) => setFilter(event.target.value) }
                    value={ filter }
                >
                    {
                        Object
                            .keys(filters)
                            .map(
                                (f) => (
                                    <option key={ f } value={ f }>{ f }</option>
                                )
                            )
                    }
                </select>
            </InventoryMenu>
            <LetterGroups
                items={ matchingParameters }
                render={
                    (parameter) => (
                        <ParameterCard
                            guard={ guard }
                            parameter={ parameter }
                            key={ parameter.id }
                        />
                    )
                }
                selector={ firstLetterSelector }
            />
        </>
    );
}
